(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('prop-types')) :
  typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types'], factory) :
  (factory((global['react-ticker'] = {}),global.React,null));
}(this, (function (exports,React,PropTypes) { 'use strict';

  React = React && React.hasOwnProperty('default') ? React['default'] : React;
  PropTypes = PropTypes && PropTypes.hasOwnProperty('default') ? PropTypes['default'] : PropTypes;

  function styleInject(css, ref) {
    if ( ref === void 0 ) ref = {};
    var insertAt = ref.insertAt;

    if (!css || typeof document === 'undefined') { return; }

    var head = document.head || document.getElementsByTagName('head')[0];
    var style = document.createElement('style');
    style.type = 'text/css';

    if (insertAt === 'top') {
      if (head.firstChild) {
        head.insertBefore(style, head.firstChild);
      } else {
        head.appendChild(style);
      }
    } else {
      head.appendChild(style);
    }

    if (style.styleSheet) {
      style.styleSheet.cssText = css;
    } else {
      style.appendChild(document.createTextNode(css));
    }
  }

  var css_248z = ".ticker-module_newsTicker__D8rcU{display:flex;margin:0;overflow:hidden}@keyframes ticker-module_slide__VbjJU{0%{transform:translateX(100vw)}to{transform:translateX(-100%)}}.ticker-module_tickerContent__yCJv2{animation:ticker-module_slide__VbjJU 60s linear infinite;display:flex;transform:translateX(100vw);width:fit-content}.ticker-module_newsTicker__D8rcU:hover .ticker-module_tickerContent__yCJv2{animation-play-state:paused}.ticker-module_tickerItem__E6j9W{align-items:center;display:flex;padding:8px}.ticker-module_tickerText__ryjAR{color:#282828;font-size:16px;line-height:1.5;padding:0 16px;white-space:nowrap}";
  var styles = {"newsTicker":"ticker-module_newsTicker__D8rcU","tickerContent":"ticker-module_tickerContent__yCJv2","slide":"ticker-module_slide__VbjJU","tickerItem":"ticker-module_tickerItem__E6j9W","tickerText":"ticker-module_tickerText__ryjAR"};
  styleInject(css_248z);

  function ReactTicker(props) {
    const {
      data,
      component,
      keyName,
      speed,
      delay,
      diretion,
      tickerClassName,
      itemClassName,
      tickerTextClassName,
      tickerStyle,
      itemStyle,
      loop
    } = props;
    return /*#__PURE__*/React.createElement("div", {
      className: [styles.newsTicker, tickerClassName].join(" "),
      style: tickerStyle
    }, /*#__PURE__*/React.createElement("div", {
      className: styles.tickerContent,
      style: {
        animationDuration: "".concat(data.length * (61 - speed), "s"),
        animationDelay: "".concat(delay, "s"),
        animationDirection: diretion,
        animationIterationCount: loop ? "infinite" : 1
      }
    }, component ? data.map((item, index) => {
      return /*#__PURE__*/React.createElement("div", {
        key: keyName ? item[keyName] : index,
        className: [styles.tickerItem, itemClassName].join(" "),
        style: itemStyle
      }, component(item, index));
    }) : data.map((item, index) => {
      return /*#__PURE__*/React.createElement("div", {
        key: 'ticker-item-' + index,
        style: itemStyle,
        className: [styles.tickerItem, itemClassName].join(" ")
      }, /*#__PURE__*/React.createElement("div", {
        className: [styles.tickerText, tickerTextClassName].join(" ")
      }, item));
    })));
  }

  ReactTicker.defaultProps = {
    data: [],
    component: null,
    keyName: null,
    speed: 30,
    delay: 0,
    direction: "normal",
    tickerClassName: "",
    itemClassName: "",
    tickerTextClassName: "",
    tickerStyle: {},
    itemStyle: {},
    loop: true
  };
  ReactTicker.propTypes = {
    data: PropTypes.array.isRequired,
    component: PropTypes.elementType,
    keyName: PropTypes.string,
    speed: PropTypes.number,
    delay: PropTypes.number,
    direction: PropTypes.oneOf(["normal", "reverse", "alternate", "alternate-reverse"]),
    tickerClassName: PropTypes.string,
    itemClassName: PropTypes.string,
    tickerTextClassName: PropTypes.string,
    tickerStyle: PropTypes.object,
    itemStyle: PropTypes.object,
    loop: PropTypes.bool
  };

  exports.ReactTicker = ReactTicker;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
